var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"h5-main"},[_c('AiBanner'),_vm._v(" "),_c('AiProductIntroduction'),_vm._v(" "),_c('AiAdvantages'),_vm._v(" "),_c('AiFunctionAndServices'),_vm._v(" "),_c('AiPlatformExample')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-972be780","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/page/h5/portalAi.vue
// module id = null
// module chunks = 